<div class="title" fxLayoutAlign="center center">
    <h4 class="widget-title" [innerHTML]="item.title"></h4>
</div>
<div>
    <div [attr.data-tf-live]="typeformId"></div>
</div>